module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Weather/Day-rain-cea0ab6da12ea08eccab0ec98351e8e7.svg";